// @flow
import React from 'react';
import { I18n } from '@lingui/react';
import { t } from '@lingui/macro';

import styled, { type StyledComponent } from 'styled-components';
import { MQ, Spacing } from '@rover/react-lib/styles';

import ZipcodeInput, { type Props as ZipcodeInputProps } from '../../formFields/ZipcodeInput';

type Props = {
  ...ZipcodeInputProps,
  isUS: boolean,
};

const StyledZipcodeInput: StyledComponent<
  React$ElementConfig<typeof ZipcodeInput>,
  {},
  any
> = styled(ZipcodeInput)`
  flex: 1;
  margin-left: ${Spacing.M};

  ${MQ.XS} {
    width: 100%;
    flex: none;
    margin-left: 0;
  }
`;

const AddresFormZipcodeField = ({ isUS, ...other }: Props) => {
  const label = isUS ? t`Zip` : t`Zip/Postal Code`;

  return (
    <I18n>
      {({ i18n }) => (
        <StyledZipcodeInput
          label={i18n._(label)}
          name="zip"
          data-qa-id="input-text-address-zip-code"
          {...other}
        />
      )}
    </I18n>
  );
};

export default AddresFormZipcodeField;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/AddressForm/AddressFormZipcodeField.jsx